module.exports = __webpack_public_path__ + "static/media/We.e601504c.jpg";